export default "__VITE_ASSET__CG204M55__"